<template>
  <svg
    class="line"
    width="973"
    height="1145"
    viewBox="0 0 973 1145"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <mask id="line">
        <path
          d="M9 15C428.374 248.656 416.945 741.661 224.268 672.108C65.2089 614.691 318.747 96.3893 683.108 208.783C1072.18 328.801 480.995 1014.22 318.747 1114.3C156.498 1214.38 215.896 739.892 971.726 723.146"
        />
      </mask>
    </defs>
  </svg>
</template>
